import router from '../../../src/router'
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';

const state = {
    fbaseAuth: false,
    userId: null,
    firstName: null,
    lastName: null,
    email: null,
    phone: null,
    city: null,
    
    // verifyCode: '',
    showVerifyCode: false,
    verifyError: false,
    smsFailed: false,
    phoneExists: null,
    phoneSearched: null,
    
    routedNewUser: false
};
const getters = {
    userId: (state) => {return state.userId},
    phone: (state) => {return state.phone},
    email: (state) => {return state.email},
    isAuthenticated: (state) => {return state.fbaseAuth},
    userName: (state) => {return state.firstName + ' ' + state.lastName},
    // verifyCode: (state) => {return state.verifyCode},
    showVerifyCode: (state) => {return state.showVerifyCode},
    verifyError: (state) => {return state.verifyError},
    phoneExists: (state) => {return state.phoneExists},
    phoneSearched: (state) => {return state.phoneSearched},
    smsFailed: (state) => {return state.smsFailed},
    routedNewUser: (state) => {return state.routedNewUser},
    city: (state) => {return state.city},
};
const mutations = {
    storeUserInfo: (state,authData) => {
        state.userId = authData.userId
        state.email = authData.email
        state.phone = authData.phone
        state.firstName = authData.firstName
        state.lastName = authData.lastName
        state.city = authData.city
    },
    // clearAuth(state) {
    //     state.userId = null
    //     state.email = null
    //     state.fbaseAuth = false
    //     state.phone = null
    //     state.firstName = null
    //     state.lastName = null
    // },
    verifyLogin(state) {
        firebase.auth().currentUser ? state.fbaseAuth = true : state.fbaseAuth = false
    },
    setUserId(state,userId) {
        state.userId = userId
    },
    smsSuccessUpdate(state) {
        state.showVerifyCode = true
        state.verifyError = false
        state.smsFailed = false
    },
    signInRouteUpdate(state) {
        state.showVerifyCode = false
        state.verifyError = null
        state.smsFailed = null
        state.routedNewUser = true
    },
    smsFailureUpdate(state) {
        state.smsFailed = true
    },
    signInFailureUpdate(state) {
        state.verifyError = true
        state.showVerifyCode = false
        // state.verifyCode = ''
    },
    phoneSearchUpdate(state) {
        state.phoneSearched = true
    },
    phoneExistence(state, snapshot) {
        snapshot.exists() ? state.phoneExists = true : state.phoneExists = false
    },
    logOutCleanUp(state) {
        state.fbaseAuth = false
        state.userId = null
        state.firstName = null
        state.lastName = null
        state.email = null
        state.phone =  null
        state.city = null
        state.showVerifyCode = false
        state.verifyError = false
        state.smsFailed = false
        state.phoneExists = null
        state.phoneSearched = null
    },
};
const actions = {
    smsAuthenticate({ dispatch },phoneNumber) {
        firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL)
        .then(() => {
            // Existing and future Auth states are now persisted in the current
            // session only. Closing the window would clear any existing state even
            // if a user forgets to sign out.
            // ...
            // New sign-in will be persisted with session persistence.
            return dispatch('sendSMSToken',phoneNumber)
        })
        .catch(function(error) {
            // Handle Errors here.
            // var errorCode = error.code;
            // var errorMessage = error.message;
            // eslint-disable-next-line no-console
            console.log('sms auth error code :',error.code,' message :',error.message)
        });
    },
    sendSMSToken({ commit },phoneNumber) {
        firebase.auth().signInWithPhoneNumber(phoneNumber, window.recaptchaVerifier)
        .then( (confirmationResult) => {
        // SMS sent. Prompt user to type the code from the message, then sign the
        // user in with confirmationResult.confirm(code).
        window.confirmationResult = confirmationResult;
        // eslint-disable-next-line no-console
        console.log('SMS is sent!')
        commit('smsSuccessUpdate')
        })
        .catch( (error) => {
        // Error; SMS not sent
        // ...
        // eslint-disable-next-line no-console
        console.log('error sending sms',error)
        commit('smsFailureUpdate')
        // window.recaptchaVerifier.render().then(function(widgetId) {
        //     firebase.auth.RecaptchaVerifier.reset(widgetId);
        // })
        });
    },
    signIn({ dispatch, commit },verifyCode) {
        window.confirmationResult.confirm(verifyCode).then( (result) => {
        // User signed in successfully.
        commit('setUserId',result.user.uid)
        dispatch('checkLogin')
        // eslint-disable-next-line no-console
        // console.log('signin userid',this.user)
        // firebase.database().ref('/users/'+ this.user).set(userData)
        // ...
        }).catch( (error) => {
        // User couldn't sign in (bad verification code?)
        // ...
        // eslint-disable-next-line no-console
        console.log('bad verification code, try again', error.message)
        commit('signInFailureUpdate')
        });
    },
    storeUser({ state },userData) {
        if (!state.userId) return
        // eslint-disable-next-line no-console
        // console.log('recording new user...')
        firebase.database().ref('/users/'+ state.userId).set(userData).then(
            () => {
            // eslint-disable-next-line no-console
            // console.log('new user registration success!')
            router.push('/feed')
            }
        )
        .catch( error => {
            // eslint-disable-next-line no-console
            console.log(error)
        })
    },
    phoneLookup({ commit, state }) {
        firebase.database().ref('/users/'+state.userId).once('value').then(snapshot => {
            // eslint-disable-next-line no-console
            // console.log('phone search matched user')
            // const matchedUsers = Object.values(snapshot.val()).filter(element => element.phone == this.phone)
            commit('phoneSearchUpdate')
            commit('phoneExistence',snapshot)
            // matchedUsers.length == 0 ? this.phoneExists = false : this.phoneExists = true
        
        })
        .catch(error => {
            // eslint-disable-next-line no-console
            console.log('error searching phone number',error)
        })
    },
    signUpRouter({ dispatch, commit, state },registrationData) {
        firebase.database().ref('/users/'+ state.userId).once('value')
        .then(snapshot => {
            // eslint-disable-next-line no-console
            // console.log('phone search matched user')
            // const matchedUsers = Object.values(snapshot.val()).filter(element => element.phone == this.phone)
            commit('phoneSearchUpdate')
            commit('phoneExistence',snapshot)
            // matchedUsers.length == 0 ? this.phoneExists = false : this.phoneExists = true
            // console.log(this.$v.$invalid)
            if (state.phoneExists) {
                // eslint-disable-next-line no-console
                // console.log('phone exists, not registering')
                setTimeout(() => { router.push('/feed') },1000)
                return
            }
            dispatch('storeUser',registrationData)
            dispatch('checkLogin')
            // eslint-disable-next-line no-console
            // console.log('new user registered and routed to feed')
            // setTimeout(() => { router.push('/feed') },1000)
        })
        .catch(error => {
            // eslint-disable-next-line no-console
            console.log('error searching phone number: ',error)
        })
    },
    signInRouter({ dispatch, commit, state }) {
        firebase.database().ref('/users/' + state.userId).once('value').then(snapshot => {
            // eslint-disable-next-line no-console
            // console.log('phone search matched a user')
            // const matchedUsers = Object.values(snapshot.val()).filter(element => element.phone == this.phone)
            commit('phoneSearchUpdate')
            commit('phoneExistence',snapshot)
            // matchedUsers.length == 0 ? this.phoneExists = false : this.phoneExists = true
            // console.log(this.$v.$invalid)
            if (state.phoneExists) {
                // eslint-disable-next-line no-console
                // console.log('phone exists, loggedIn')
                dispatch('checkLogin')
                setTimeout(() => { router.push('/feed') },1000)
                return
            }
            firebase.auth().signOut()
            .then(
            // eslint-disable-next-line no-console
            () => console.log('signed out'))
            // this.routedNewUser = true
            // update state to reset phone verification
            commit('signInRouteUpdate')
            // reset state vars
            commit('logOutCleanUp')
            router.push('/signup')
            .catch(
            // eslint-disable-next-line no-console
            (error) => console.log(error)) 
        })
        .catch(error => {
            // eslint-disable-next-line no-console
            console.log('error searching phone number',error)
        })
    },
    loadUserData({ commit },currentUser) {
        // var userRef = firebase.database().ref('/users/'+ currentUser.uid)
        // eslint-disable-next-line no-console
        // console.log("updateUserData")
        firebase.database().ref('/users/'+ currentUser.uid).once('value').then(snapshot => {
                // eslint-disable-next-line no-console
                // console.log(snapshot)
                if (snapshot.exists()) {
                    commit('storeUserInfo',{
                        userId: currentUser.uid,
                        email: snapshot.val().email,
                        phone: snapshot.val().phone,
                        firstName: snapshot.val().firstName,
                        lastName: snapshot.val().lastName,
                        city: snapshot.val().city,
                    })
                }
            
            })
            .catch(error => {
                // eslint-disable-next-line no-console
                console.log('error searching phone number',error)
            })
    },
    checkLogin({ dispatch }) {
        const loggedUser = firebase.auth().currentUser
        // // eslint-disable-next-line no-console
        // console.log(loggedUser)
        if (!loggedUser) return
        // user is logged in - get userdata from from firebase and update state
        dispatch('loadUserData',loggedUser)
    },
    signOut({ commit }) {
        firebase.auth().signOut().then(
            // eslint-disable-next-line no-console
            () => console.log('signed out')
          )
          .catch(
            // eslint-disable-next-line no-console
            (error) => console.log(error)
        )
        commit('logOutCleanUp')
        router.push('/signin')
        //eslint-disable-next-line no-console
          .then(response => console.log(response))
    },
    // autoSignOut({ commit },expirationTime) {
    //         setTimeout(() => {
    //           commit('clearAuth')
    //         },expirationTime*1000)
    // },
    // signup({ commit,dispatch },payload) {
    //     const signupData = {
    //         email: payload.email,
    //         password: payload.password,
    //         returnSecureToken: true
    //     }
    //     authAxios.post('/accounts:signUp?key=AIzaSyB7p-592NJ5IUwWWZxdCvVw9bjjykrxY5k',signupData)
    //     .then(resp => { 
    //     // eslint-disable-next-line no-console
    //     console.log(resp)
    //     commit('storeUserInfo',{
    //         idToken:resp.data.idToken,
    //         userId: resp.data.localId,
    //         email:resp.data.email
    //     })
    //     dispatch('autoSignOut',resp.data.expiresIn)
    //     // store token in localstorage
    //     const now = new Date()
    //     const expirationDate = new Date(now.getTime() + resp.data.expiresIn*1000)
    //     localStorage.setItem('idToken',resp.data.idToken)
    //     localStorage.setItem('userId',resp.data.localId)
    //     localStorage.setItem('expirationDate', expirationDate)
    //     localStorage.setItem('email',resp.data.email)
    //     // remove password from user database
    //     delete payload.password
    //     dispatch('saveUserData',payload)
    //     router.push('/feed')
    //     })
    //     .catch( error => {
    //         if (error.response) {
    //             const errMessage = error.response.data.error.message
    //             if (errMessage == "EMAIL_EXISTS") {
    //                 alert("This email address aleady have an associated account!"+ 
    //                 " If you forgot your password you can use password reset from Sign in page")
    //             }
    //             // eslint-disable-next-line no-console
    //             console.log(error.response)
    //         }
    //     }
    //     )
    // },
    // signin({ commit,dispatch },authData) {
    //     authAxios.post('/accounts:signInWithPassword?key=AIzaSyB7p-592NJ5IUwWWZxdCvVw9bjjykrxY5k', {
    //         email: authData.email,
    //         password: authData.password,
    //         returnSecureToken: true
    //       })
    //       .then( resp => {
    //         commit('fullName')
    //         commit('storeUserInfo',{
    //             idToken: resp.idToken,
    //             userId: resp.localId,
    //             email: resp.email
    //         })
    //         dispatch('autoSignOut',resp.data.expiresIn)
    //         const now = new Date()
    //           const expirationDate = new Date(now.getTime() + resp.data.expiresIn*1000)
    //           localStorage.setItem('idToken',resp.data.idToken)
    //           localStorage.setItem('userId',resp.data.localId)
    //           localStorage.setItem('expirationDate', expirationDate)
    //           localStorage.setItem('email',resp.data.email)
    //         // eslint-disable-next-line no-console
    //           console.log(resp)
    //         router.push('/feed')
    //       })
    //       .catch( error => {
    //         //   eslint-disable-next-line no-console
    //         console.log(error.response.data.error.message)
    //       })
    // },
    // saveUserData({ state },userData) {
    //     if (!state.idToken) return
    //     axios.post('/userdata.json'+'?auth='+state.idToken,userData)
    //     .then( resp => {
    //         // eslint-disable-next-line no-console
    //         console.log(resp)
    //     })
    //     .catch(err => {
    //         // eslint-disable-next-line no-console
    //         console.log(err)
    //     })
    // },


};

export default {
    state,
    getters,
    mutations,
    actions,
    namespaced: true,
};